import React, { Component } from 'react';
import { connect } from 'react-redux';

import classNames from './../utils/classNames';
import Emoji from './../components/Emoji';

import { ordersFindFetchIfNeeded, ordersFindSetSorting } from './../store/ordersFind/actions';
import { getOrdersFilteredSorted } from './../store/ordersFind/selectors';

import { StickyContainer, StickyHead, StickyBody } from './Sticky';
import OrdersTableFilter from './OrdersTableFilter';
import OrdersTableRow from './OrdersTableRow';
import UpToButton from './UpToButton';
import TableSortingHead from './TableSortingHead';

const COUNT_STEP = 20;

class OrdersTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            count: COUNT_STEP,
            isSearch: false
        }

        this.onMoreClick = this.onMoreClick.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
    }

    componentDidMount() {
        const { loadOrders } = this.props;
        loadOrders();
    }

    onSearchChange(isSearch) {
        this.setState(state => Object.assign({}, state, {
            isSearch
        }))
    }

    onMoreClick() {
        const { orderList } = this.props;
        this.setState(state => Object.assign({}, state, {
            count: Math.min(state.count + COUNT_STEP, orderList.length)
        }));
    }

    renderHeader() {
        const { setSorting, sorting } = this.props;
        return (
            <div className="table-header">
                <div className="row">
                    <div className="col-1"></div>
                    <div className="col-5">Order Number</div>
                    <div className="col-6">Subject</div>
                    <div className="col-3">Type of work</div>
                    <div className="col-3">
                        <TableSortingHead sorting={sorting} setSorting={setSorting} field="pregrader_price">You’ll earn</TableSortingHead>
                    </div>
                    <div className="col-2">
                        <TableSortingHead sorting={sorting} setSorting={setSorting} field="pages">Size</TableSortingHead>
                    </div>
                    <div className="col-4">
                        <TableSortingHead sorting={sorting} setSorting={setSorting} field="writer_last_graded_at">Last grading</TableSortingHead>
                    </div>
                    <div className="col-2">
                        <TableSortingHead sorting={sorting} setSorting={setSorting} field="writer_last_graded_count">Graded</TableSortingHead>
                    </div>
                    <div className="col-4">
                        <TableSortingHead sorting={sorting} setSorting={setSorting} field="grade_priority">Additional info</TableSortingHead>
                    </div>
                </div>
            </div>
        );
    }

    renderRow(order) {
        const { onSelect, selectedNumber } = this.props;
        const className = classNames('table-row', 'row', 'vertical', { 'active': selectedNumber === order.number });
        return (
            <OrdersTableRow className={className} key={order._id} number={order.number} onClick={() => onSelect(order.number)} />
        );
    }

    renderOrderList() {
        const { orderList, isLoading } = this.props;
        const { count, isSearch } = this.state;

        if (isLoading) {
            return (<div className="preloading preloading-box"><p>Loading</p></div>);
        }
        if (!orderList.length) {
            return isSearch ? (
                <div className="page-not-result">
                    <Emoji id="verySad" />
                    <h1>Oops, order #.... is not found.</h1>
                    <p className="notes">Please check the number you try to found. <br />Or ask your team leader for a help.</p>
                </div>
            ) : (
                    <div className="page-not-result">
                        <Emoji id="crySad" />
                        <h1>Oops, we don't have orders matching this filter set.</h1>
                        <p className="notes">Please try again with other filter configuration.</p>
                    </div>
                );
        }
        return orderList.slice(0, count).map(order => this.renderRow(order));
    }

    renderNextButton() {
        const { orderList, isLoading } = this.props;

        if (!orderList.length || isLoading) {
            return null;
        }

        const { count } = this.state;
        const nextCount = Math.min(orderList.length - count, COUNT_STEP);
        if (nextCount <= 0) {
            return null;
        }
        return (
            <button type="button" className="btn btn-show-next" onClick={this.onMoreClick}>Show next {nextCount} orders</button>
        );
    }

    render() {
        const { isSearch } = this.state;
        const { typeId } = this.props;
        return (
            <div className="table orders-table">
                <StickyContainer className="sticky-table">
                    <StickyHead className="sticky-table-head" classNameFixed="sticky-table-head-fixed">
                        <OrdersTableFilter isSearch={isSearch} onSearchChange={this.onSearchChange} className="table-filter" typeId={typeId} />
                        {this.renderHeader()}
                    </StickyHead>
                    <StickyBody className="sticky-table-body">
                        {this.renderOrderList()}
                    </StickyBody>
                </StickyContainer>
                <UpToButton />
                {this.renderNextButton()}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const orderList = getOrdersFilteredSorted[ownProps.typeId](state);
    const isLoading = state.ordersFind.isFetching;
    const sorting = state.ordersFind.sorting;
    return { orderList, isLoading, sorting };
};

const mapDispatchToProps = dispatch => {
    return {
        loadOrders: () => dispatch(ordersFindFetchIfNeeded()),
        setSorting: value => dispatch(ordersFindSetSorting(value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrdersTable);


// WEBPACK FOOTER //
// ./src/components/OrdersTable.js